




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Feedback extends Vue {
  @Prop({ default: '88' }) readonly width?: string;
  @Prop({ default: '88' }) readonly height?: string;
}
